<template>
  <div class="body-div">
    <h6>At 5 a.m. I've moved:</h6>
    <div class="main-chart">
      <canvas id="retention-main-chart" width="1"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

const depositsChartData = {
  type: "bar",
  options: {
    onClick: evt => {
      this.clickDepChart(evt);
    },
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        /*     backgroundColor: function (context) {
                           return context.dataset.backgroundColor;
                         },*/
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? value : value;
        }
      }
    },
    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 9
          }
        }
        /*   {

                      id: "bar-x-axis2",
                      stacked: true,
                      gridLines: {
                        display:false,
                        fontSize: 0
                      },
                      ticks: {
                       display:false
                      }
                    }*/
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      mode: "index",
      intersect: false
    }
  }
};
export default {
  name: "RetentionsCharts.component",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      depositsChartData: depositsChartData,

      CrChartBar: null,
      arrData: []
    };
  },
  mounted() {
    this.arrData = this.data;
    this.createCrChart();
  },
  watch: {
    data: function() {
      this.arrData = this.data;
    }
  },
  methods: {
    createCrChart() {
      let allData = this.arrData;
      let labels = [];
      let Count = [];
      let chartData = this.depositsChartData;
      let opt = chartData.options;
      let chartId = "retention-main-chart";

      Object.keys(allData).map(data => {
        if (allData[data] === 0) {
          return;
        }
        labels.push(data);
        Count.push(allData[data]);
      });

      if (this.CrChartBar) {
        this.CrChartBar.destroy();
      }

      const data = {
        labels: labels,

        datasets: [
          {
            type: "bar",
            label: "Removed",
            data: Count,
            fill: true,
            borderColor: "black",
            backgroundColor: "rgba(255,0,0,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: false,
            minBarLength: function(value) {
              return value.dataset.data[value.dataIndex] + 5;
            }
          }
        ]
      };

      const ctx = document.getElementById(chartId);

      this.CrChartBar = new Chart(ctx, {
        type: chartData.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 5px 5px 1px 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.main-chart {
  min-width: 720px;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}
</style>
